import sortBy from 'lodash.sortby';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Typography } from '@components/Typography';
import { formatNumber, formatPercentNumber } from '@helpers/formatNumbers';
import { getTableArrow, TableCellText, Text } from '.';

export const getCollapsibleTableBody = (data, index, isQr) => {
    const rowCompanyId = data?.find((_, dataIndex) => dataIndex === index)?.id;
    const tableData = sortBy(
        data?.filter(item => item.id === rowCompanyId && item.surveyTemplateId),
        item => item?.surveyName?.toLowerCase(),
    );

    const width = isQr ? '18%' : '14%';
    return tableData.map(row => {
        const {
            surveyTemplateId,
            surveyName,
            sentSurveys,
            responsesReceived,
            responsesReceivedPercent,
            responsesReceivedChange,
            leaveReviewClicked,
            leaveReviewClickedPercent,
            leaveReviewClickedChange,
            openedSurveys,
            openedSurveysPercent,
            openedSurveysChange,
        } = row;

        return surveyTemplateId
            ? [
                  {
                      component: (
                          <IconButton style={{ opacity: 0, cursor: 'auto' }}>
                              <KeyboardArrowUpIcon />
                          </IconButton>
                      ),
                      width: '5%',
                  },
                  {
                      component: (
                          <Typography variant="subtitle2" align="left" sx={{ minWidth: '100px' }}>
                              {surveyName}
                          </Typography>
                      ),
                      width: '100px',
                  },
                  {
                      component: (
                          <Typography variant="body2" align="right" sx={{ minWidth: '89px' }}>
                              {!isQr ? formatNumber(sentSurveys) : formatNumber(openedSurveys)}
                          </Typography>
                      ),
                      width,
                  },
                  ...(!isQr
                      ? [
                            {
                                component: (
                                    <TableCellText variant="body2" align="right" sx={{ minWidth: '89px' }}>
                                        {formatNumber(openedSurveys)}
                                        <Text withIcon={openedSurveysChange}>
                                            ({formatPercentNumber(openedSurveysPercent)})
                                        </Text>
                                        {getTableArrow(openedSurveysChange)}
                                    </TableCellText>
                                ),
                                width,
                            },
                        ]
                      : []),
                  {
                      component: (
                          <TableCellText variant="body2" align="right" sx={{ minWidth: '89px' }}>
                              {formatNumber(responsesReceived)}
                              <Text withIcon={responsesReceivedChange}>
                                  ({formatPercentNumber(responsesReceivedPercent)})
                              </Text>
                              {getTableArrow(responsesReceivedChange)}
                          </TableCellText>
                      ),
                      width,
                  },
                  {
                      component: (
                          <TableCellText variant="body2" align="right" sx={{ minWidth: '89px' }}>
                              {formatNumber(leaveReviewClicked)}
                              <Text withIcon={leaveReviewClickedChange}>
                                  ({formatPercentNumber(leaveReviewClickedPercent)})
                              </Text>
                              {getTableArrow(leaveReviewClickedChange)}
                          </TableCellText>
                      ),
                      width,
                  },
                  {
                      component: (
                          <TableCellText variant="body2" align="right" sx={{ minWidth: '89px' }}></TableCellText>
                      ),
                      width,
                  },
              ]
            : null;
    });
};
